import {cn} from '@sollapay/ui';
import {ROW_CONCEAL_CLASS, ROW_REVEAL_CLASS} from '@sollapay/ui/components';

import {DateCell} from '@/components';

import {TrustAccountCtaButton} from './TrustAccountCtaButton';

import type {FC, ReactNode} from 'react';

export interface TrustAccountRowActionProps {
  date: Date | string;
  ctaLabel: string;
  onAction: () => void;
  /** Pinned at the cell's inline end and always shown, e.g. the row's more-menu. */
  menu?: ReactNode;
}

// Room kept for the ⋮ menu at the end of the cell: the date pads for it, the call to action stops short of it.
const MENU_GUTTER = {pad: 'pe-11', end: 'end-11'} as const;

/** The row's date, swapped for its call to action while the row is hovered or focused. */
export const TrustAccountRowAction: FC<TrustAccountRowActionProps> = ({
  date,
  ctaLabel,
  onAction,
  menu
}) => (
  <div
    data-slot="trust-account-row-action"
    className={cn('relative flex min-h-9 items-center', menu && MENU_GUTTER.pad)}
  >
    <div className={ROW_CONCEAL_CLASS}>
      <DateCell date={date} />
    </div>
    {/* Lifted above the row link's overlay so the button, not the row, takes the click. */}
    <div
      data-slot="row-cta"
      className={cn(
        'absolute inset-y-0 start-0 z-10 flex min-w-0 items-center',
        menu ? MENU_GUTTER.end : 'end-0',
        ROW_REVEAL_CLASS
      )}
    >
      <TrustAccountCtaButton label={ctaLabel} onAction={onAction} />
    </div>
    {menu && (
      <div data-slot="row-menu" className="absolute inset-y-0 end-0 z-10 flex items-center">
        {menu}
      </div>
    )}
  </div>
);
